"use client";
// /career-events, flag-gated v1/v2 toggle (REDESIGN_PHASE0.md per-route pattern).
// Default OFF. Preview v2 with ?_redesign=career-events (or =all). Integrator flips
// the default once v2 is parity-verified & soaked.

import CareerEventsV2 from "./_events-v2/CareerEventsV2";

// P1 prep 2026-09-27: V1 removed; prod has run V2 since REDESIGN_ALL=1.
export default function CareerEventsPage() {
  return <CareerEventsV2 />;
}
